/*
 * @Author: song
 * @Date: 2018-02-06 11:10:06
 * @Last Modified by: yan.chaoming
 * @Last Modified time: 2018-02-09 17:13:27
 */
export default {
  name: "informationdetail",
  informationDetail: {
    work_informationdetail_01: {
      url: '/data/work_information_detail.json'
    }
  }
};



// WEBPACK FOOTER //
// ./src/projects/huayu/config/dev/informationdetail.js